import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../css/SignIn.css';

const Register = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleRegister = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch('https://api.affordablecustomehr.com/psychology-ai-note-generator/api/register', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ username, email, password }),
            });

            if (response.ok) {
                navigate('/sign-in');
            } else {
                const result = await response.json();
                setError(result.error || "Registration failed");
            }
        } catch (error) {
            console.error("An error occurred:", error);
            setError("An error occurred. Please try again.");
        }
    };

    return (
        <div className="sign-in flex flex-col items-center justify-center h-screen bg-gray-100 px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">Register</h2>
            <form onSubmit={handleRegister} className="login-form w-full max-w-md bg-white p-6 rounded-lg shadow-md space-y-4">
                <div className="form-group">
                    <label htmlFor="username">Username</label>
                    <input
                        type="text"
                        id="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="password">Password</label>
                    <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                {error && <p className="error-message">{error}</p>}
                <button type="submit" className="login-button">Register</button>
            </form>
        </div>
    );
};

export default Register;
